import { render, staticRenderFns } from "./AnyIssue.vue?vue&type=template&id=1281d852&"
import script from "./AnyIssue.vue?vue&type=script&lang=js&"
export * from "./AnyIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports